import { db } from 'firebase/firebase';
import { doc, getDoc } from 'firebase/firestore';

import { ORGANIZATIONS } from '../constants';
import { USERS } from './constants';

export const getUserById = async (orgId, userId) =>
  getDoc(doc(db, ORGANIZATIONS, orgId, USERS, userId)).then(snapshot => snapshot.data());
